function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 40 40",
  fill: "none",
  strokeLinejoin: "round",
  strokeLinecap: "round",
  stroke: "currentColor",
  role: "img",
  "aria-hidden": "true"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M32.47 11.52v15.53L20 34.35 7.53 27.46V11.53L20 17.94m0 16.41V17.94m12.47-6.42L20 5.65 7.53 11.49m24.78.12L20.2 17.97m1.79 12.44l3.98-2.22m-3.98-.1l1.99-1.1m1.44-18.57l-11.84 6.16v3.05"
}));